import styled from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { ANATOMY_V2_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    position: relative;
    width: 100%;
    height: calc(100dvh - var(--header-height));

    &::before {
      position: absolute;
      z-index: -1;
      inset: 0;
      top: calc(-1 * var(--header-height));
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 24px 16px;
    min-height: 0;
  `,

  Title: styled.h1<{ $isAnatomyV2?: boolean }>`
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    color: ${COLORS.BLACK};
    margin-top: ${({ $isAnatomyV2 }) => ($isAnatomyV2 ? '24px' : '0')};
    margin-bottom: 8px;
    flex-shrink: 0;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
    }
  `,

  Subtitle: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: ${COLORS.BLACK_300};
    margin-bottom: 24px;
    flex-shrink: 0;

    ${anatomyCompact} {
      margin-bottom: ${ANATOMY_COMPACT.spacing.s24};
    }
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  `,

  Grid: styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: auto;
  `,

  TopicOption: styled.button<{
    $isSelected: boolean
    $isAnatomyV2?: boolean
  }>`
    background: ${({ $isSelected, $isAnatomyV2 }) => {
      if (!$isSelected) return COLORS.WHITE
      return $isAnatomyV2 ? '#ede7fe' : COLORS.PURPLE_100
    }};
    border: 1.5px solid
      ${({ $isSelected, $isAnatomyV2 }) => {
        if (!$isSelected) return COLORS.GRAY_30
        return $isAnatomyV2 ? ANATOMY_V2_ACCENT_COLOR : COLORS.PURPLE_400
      }};
    border-radius: 14px;
    padding: 14px 16px;
    min-height: 56px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    transition: background 0.15s, border-color 0.15s;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  `,

  Value: styled.span`
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: ${COLORS.BLACK};
    text-align: start;
  `,

  ButtonContainer: styled.div`
    margin-top: auto;
    padding-top: 16px;
    position: relative;
    background: rgba(247, 249, 252, 0.72);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: -11px;
      height: 11px;
      background: linear-gradient(
        to bottom,
        rgba(247, 249, 252, 0),
        rgba(247, 249, 252, 0.72)
      );
      pointer-events: none;
    }
  `,

  StyledButton: styled(Button)`
    width: 100%;
  `,
} as const
